import styled from 'styled-components';

export const themeConfig = {
    dark: {
        bgMain: '#343541',
        bgSidebar: '#202123',
        textMain: '#ececf1',
        textTitleMessage: '#a9a9a9',
        textSecondary: '#9b9c9f',
        bgMessageUser: '#444654',
        bgMessageBot: 'transparent',
        bgInput: '#444654',
        border: '#56586952',
        hover: '#2A2B32',
        active: '#343541',
        toastBg: '#202123',
        scrollThumb: '#565869',
        shadow: 'rgba(0,0,0,0.5)',
        codeInlineBg: '#444654',
        codeBlockBg: '#1e1e1e',
        tableHeaderBg: '#3d3d4f',
        tableRowHover: '#343541',
        linkColor: '#4d9fff',
        blockquoteBorder: '#4d9fff',

        chipBg: 'rgba(59, 130, 246, 0.06)',
        chipBorder: 'rgba(59, 130, 246, 0.15)',
        chipHoverBg: 'rgba(59, 130, 246, 0.12)',
        chipColor: '#60a5fa',
    },
    light: {
        bgMain: '#ffffff',
        bgSidebar: '#f7f7f8',
        textMain: '#343541',
        textTitleMessage: '#343541',
        textSecondary: '#6e6e80',
        bgMessageUser: '#f0f0f0',
        bgMessageBot: 'transparent',
        bgInput: '#ffffff',
        border: '#d9d9e3',
        hover: '#ececf1',
        active: '#d9d9e3',
        toastBg: '#ffffff',
        scrollThumb: '#d9d9e3',
        shadow: 'rgba(0,0,0,0.1)',
        codeInlineBg: '#e9ecef',
        codeBlockBg: '#282c34',
        tableHeaderBg: '#495057',
        tableRowHover: '#e9ecef',
        linkColor: '#007bff',
        blockquoteBorder: '#007bff',

        chipBg: 'rgba(59, 130, 246, 0.04)',
        chipBorder: 'rgba(59, 130, 246, 0.12)',
        chipHoverBg: 'rgba(59, 130, 246, 0.08)',
        chipColor: '#1d4ed8',
    }
};

export const ChatbotWrapper = styled.div`
    /* --- Estilos Globales del Componente --- */
    & {
        font-family: 'Work Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        margin: 0;
        padding: 0;
        background-color: ${props => props.theme.bgMain};
        color: ${props => props.theme.textMain};
        display: flex;
        height: 100dvh; 
        width: 100%;
        overflow: hidden;
        transition: background-color 0.3s ease, color 0.3s ease;
        position: relative;
        z-index: 0;
    }

    * {
        box-sizing: border-box;
        scrollbar-width: thin;
        scrollbar-color: ${props => props.theme.scrollThumb} transparent;
    }

    /* --- Custom Scrollbar para Chrome, Safari y Edge --- */
    ::-webkit-scrollbar {
        width: 8px; /* Hace el scrollbar más delgado y elegante */
        height: 8px; /* Para scroll horizontal si lo hubiera */
    }

    ::-webkit-scrollbar-track {
        background: transparent; /* Fondo invisible para que se funda con tu bgMain */
    }

    ::-webkit-scrollbar-thumb {
        background-color: ${props => props.theme.scrollThumb};
        border-radius: 10px; /* Bordes redondeados */
        border: 2px solid ${props => props.theme.bgMain}; /* Crea un efecto de margen interno */
    }

    ::-webkit-scrollbar-thumb:hover {
        background-color: ${props => props.theme.textSecondary}; /* Se ilumina un poco al pasar el mouse */
    }

    /* Links heredan color para funcionar en Light Mode */
    a { color: inherit; text-decoration: none; }
    
    /* --- Nuevo Botón de Tema --- */
    .theme-toggle-btn {
        background: transparent;
        border: 1px solid ${props => props.theme.border};
        color: ${props => props.theme.textMain};
        border-radius: 8px;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s ease;
    }
    .theme-toggle-btn:hover {
        background-color: ${props => props.theme.hover};
    }

    /* --- Notificaciones toast --- */
    .toast-container {
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 9999;
    }
    
    .toast {
        background: ${props => props.theme.toastBg};
        color: ${props => props.theme.textMain};
        padding: 12px 20px;
        border-radius: 6px;
        margin-bottom: 10px;
        box-shadow: 0 4px 12px ${props => props.theme.shadow};
        transform: translateX(400px);
        transition: transform 0.3s ease;
        max-width: 300px;
        display: flex;
        align-items: center;
        gap: 8px;
        border: 1px solid ${props => props.theme.border};
    }
    
    .toast.show { transform: translateX(0); }
    .toast.success { background: #27ae60; border: none; color: white; }
    .toast.error { background: #e74c3c; border: none; color: white; }
    
    /* --- Sidebar --- */
    .sidebar {
        width: 280px;
        min-width: 260px;
        max-width: 320px;
        background-color: ${props => props.theme.bgSidebar};
        color: ${props => props.theme.textMain};
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        border-right: 1px solid ${props => props.theme.border};
        transition: background-color 0.3s ease, left 0.3s ease; /* Transición suave */
        position: relative;
        z-index: 1000;
        height: 100%;
    }
    
    .sidebar-header {
        padding: 20px;
        background-color: transparent;
    }

    .sidebar-header h3 {
        margin: 0;
        font-size: 16px;
        color: ${props => props.theme.textMain};
    }
    
    .sidebar-header span { cursor: pointer; }
    .sidebar-header span:hover { color: ${props => props.theme.textSecondary}; }

    /* Sidebar Footer */
    .sidebar-footer {
        padding: 0px 20px;
        margin-top: auto;
        border-top: 1px solid ${props => props.theme.border};
        background-color: transparent;
        position: relative;
        z-index: 1001;
    }
    
    .powered-by {    
        font-size: 10px;
        color: ${props => props.theme.textSecondary};
    }
    
  
    .user-chat-info {
        display: flex;
        align-items: center;
        gap: 12px;
        background: none;
        border: none;
        width: 100%;
        padding: 8px;
        border-radius: 6px;
        cursor: pointer;
        transition: background-color 0.2s;
    }
    .user-chat-info:hover {
        background-color: ${props => props.theme.hover};
    }
    
    .user-chat-avatar {
        font-size: 12px;
        font-weight: bold;
        background: ${props => props.theme.bgInput};
        color: ${props => props.theme.textMain};
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        flex-shrink: 0;
    }
    
    .user-chat-name {
        font-size: 14px;
        font-weight: 500;
        color: ${props => props.theme.textTitleMessage};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
    }
    .user-chat-plan {
        font-size: 14px;
        font-weight: 500;
        color: ${props => props.theme.textSecondary};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-style: italic;
        text-align: left;
    }
    
    .user-chat-names > span { line-height: 1.2; }
    
    .login-btn-chat {        
        padding: 2px;
        color: ${props => props.theme.textTitleMessage};
        // border: 1px solid #bdbdc3ff;
        // border-radius: 25px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        transition: background-color 0.2s;
        //background-color: #aaaaabff;
    }

    .chevron-login{
        font-size: 12px;
        color: ${props => props.theme.textTitleMessage};
    }
    
    .cont-signin-buttons{
        padding: 2px;
        border-radius: 10px;
    }
    .cont-signin-buttons:hover { background-color: ${props => props.theme.border}; }

    .subscribe-btn-chat {        
        width: 100%;
        padding: 5px;
        color: #ffffffff;
        border: 1px solid #636363ff;
        border-radius: 25px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        transition: background-color 0.2s;
        background-color: #636363ff;
        text-decoration: none;
    }
    
    /* Menú Flotante de Usuario */
    .user-menu-popup {
        position: absolute;
        bottom: 100%;
        left: 0;
        width: 100%;
        background: ${props => props.theme.bgSidebar};
        border: 1px solid ${props => props.theme.border};
        border-radius: 6px;
        box-shadow: 0 -4px 12px ${props => props.theme.shadow};
        z-index: 1004;
        padding: 5px;
        margin-bottom: 5px;
    }
    
    .user-menu-item {
        display: block;
        width: 100%;
        text-align: left;
        padding: 10px 12px;
        font-size: 14px;
        color: ${props => props.theme.textMain};
        border: none;
        background: none;
        border-radius: 4px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-decoration: none;
    }
    
    .user-menu-item:hover { background-color: ${props => props.theme.hover}; }
    .user-menu-item.disabled { color: ${props => props.theme.textSecondary}; cursor: not-allowed; }
    .user-menu-item.logout { color: #e74c3c; }
    .user-menu-item.logout:hover { background-color: #e74c3c; color: white; }
    
    .user-menu-separator {
        height: 1px;
        background: ${props => props.theme.border};
        margin: 5px 10px;
    }

    /* Listas y Conversaciones */
    .new-chat-btn {
        width: 100%;
        padding: 12px;
        background-color: transparent;
        color: ${props => props.theme.textMain};
        border: 1px solid ${props => props.theme.border};
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
        margin-top: 15px;
    }
    .new-chat-btn:hover { background-color: ${props => props.theme.hover}; }
    
    .conversations-list { 
        flex: 1; 
        overflow-y: auto; 
        padding: 20px; 
        overflow-x: visible;
    }

    .new-chat-action{
        color: ${props => props.theme.textSecondary};
         font-size: 14px;
         font-weight: 500;
    }

    .conversation-cont-title { 
        color: ${props => props.theme.textSecondary};
        font-size: 14px;
        font-weight: 500;

     }

     .empty-chats-notification{
        color: ${props => props.theme.textSecondary};
        font-size: 14px;
        font-weight: 500;
     }
    
    .conversation-item {
        padding: 0px 0px;
        margin-bottom: 5px;
        border-radius: 6px;
        cursor: pointer;
        transition: background-color 0.2s;
        border-left: 3px solid transparent;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: ${props => props.theme.textMain};
        overflow: visible;
    }
    
    .conversation-item:hover { background-color: ${props => props.theme.hover}; }
    
    .conversation-item.active {
        background-color: ${props => props.theme.hover};
        border-left-color: ${props => props.theme.hover};
    }
    
    .conversation-content { 
        flex: 1; 
        min-width: 0; 
        padding: 0 12px;
    }
    .conversation-title {
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${props => props.theme.textTitleMessage};
    }
    
    .conversation-date { font-size: 12px; color: ${props => props.theme.textSecondary}; }
    
    .conversation-actions { 
        opacity: 0; 
        transition: opacity 0.2s; 
        margin-left: 8px; 
        flex-shrink: 0; 
        position: relative; 
        z-index: 1002;
        overflow: visible;
    }

    .conversation-item:hover .conversation-actions { 
    opacity: 1;
     }
    
    .menu-btn {
        background: transparent;
        color: ${props => props.theme.textSecondary};
        border: none;
        border-radius: 4px;
        padding: 0px;
        cursor: pointer;
        font-size: 16px;
        transition: all 0.2s;
        position: relative;
        z-index: 1002;
    }
    .menu-btn:hover { background: ${props => props.theme.hover}; color: ${props => props.theme.textMain}; }
    
    .dropdown-menu-chat {
        top: calc(100% + 4px);
        left: rect.right + 8px;
        background: ${props => props.theme.bgSidebar};
        border: 1px solid ${props => props.theme.border};
        border-radius: 6px;
        box-shadow: 0 4px 12px ${props => props.theme.shadow};
        min-width: 140px;
        z-index: 10000;
        display: none;
        margin-top: 4px;
        pointer-events: auto;
    }
    .dropdown-menu-chat.show { display: block; }
    
    .dropdown-item-chat {
        padding: 10px 15px;
        cursor: pointer;
        color: ${props => props.theme.textMain};
        font-size: 14px;
        border: none;
        background: none;
        width: 100%;
        text-align: left;
        transition: background-color 0.2s;
    }
    .dropdown-item-chat:hover { background-color: ${props => props.theme.hover}; }
    .dropdown-item-chat.delete-chat { color: #e74c3c; }
    .dropdown-item-chat.delete-chat:hover { background-color: #e74c3c; color: white; }
    .dropdown-item-chat.confirming { background-color: #c0392b !important; color: white !important; font-weight: bold; border: 2px solid #a93226; }
    
    /* --- Main content --- */
    .main-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0;
        background-color: ${props => props.theme.bgMain};
        transition: background-color 0.3s ease;
        position: relative;
        z-index: 1;
    }
    
    .chat-header {
        padding: 12px 20px;
        background-color: ${props => props.theme.bgMain};
        border-bottom: 1px solid ${props => props.theme.border};
        box-shadow: none;
        position: relative;
        z-index: 2;
        transition: all 0.3s ease;
    }

    .chat-header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
    }

    .chat-header-left {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

     .header-title-group {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .chat-header-title {
        font-size: 18px;
        font-weight: 600;
        margin: 0;
        color: ${props => props.theme.textMain};
        letter-spacing: -0.3px;
    }

    .chat-header-subtitle {
        font-size: 13px;
        color: ${props => props.theme.textSecondary};
        opacity: 0.7;
        font-weight: 400;
    }
    
    .chat-header h1 { margin: 0; font-size: 24px; color: ${props => props.theme.textMain}; }

    /* Badge de Suscripción */
    .subscription-badge {
        font-size: 11px;
        font-weight: 600;
        padding: 4px 10px;
        border-radius: 12px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        transition: all 0.2s ease;
    }

    .subscription-badge.guest {
        background: rgba(180, 101, 10, 0.38);
        color: ${props => props.theme.textMain};
        border: 1px solid rgba(180, 101, 10, 0.55);
    }

    .subscription-badge.free {
        background: rgba(180, 101, 10, 0.38);
        color: #ffffff;
        border: 1px solid rgba(180, 101, 10, 0.55);
    }

    .subscription-badge.basic {
        background: rgba(59, 130, 246, 0.15);
        color: #60a5fa;
        border: 1px solid rgba(59, 130, 246, 0.3);
    }
    
    .subscription-badge.pro {
        background: rgba(168, 85, 247, 0.15);
        color: #a78bfa;
        border: 1px solid rgba(168, 85, 247, 0.3);
    }

    /* Tema claro - Ajuste de badges */
    [data-theme="light"] .subscription-badge.free {
        background: rgba(100, 116, 139, 0.1);
        color: #64748b;
    }
    
    [data-theme="light"] .subscription-badge.basic {
        background: rgba(59, 130, 246, 0.1);
        color: #3b82f6;
    }
    
    [data-theme="light"] .subscription-badge.pro {
        background: rgba(168, 85, 247, 0.1);
        color: #8b5cf6;
    }
    
    .chat-header-right {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    /* Selector de Contexto */
    .context-selector-wrapper { 
        position: relative;         
        z-index: 50; 
    }
    .context-selector {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 12px;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid ${props => props.theme.border};
        border-radius: 8px;
        color: ${props => props.theme.textMain};
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
    }
    .context-selector:hover { 
        background: ${props => props.theme.hover};
        border-color: rgba(255, 255, 255, 0.2);
    }
    
    .context-icon {
        font-size: 16px;
    }

    .context-name {
        font-weight: 500;
        color: ${props => props.theme.textMain};
    }

    /* Tema claro - Context Selector */
    [data-theme="light"] .context-selector {
        background: rgba(0, 0, 0, 0.03);
    }
    
    [data-theme="light"] .context-selector:hover {
        background: rgba(0, 0, 0, 0.05);
        border-color: rgba(0, 0, 0, 0.15);
    }

    .context-arrow {
        font-size: 12px;
        opacity: 0.6;
        margin-left: 4px;
        color: ${props => props.theme.textSecondary};
    }

    .context-selector .text-light { 
        color: ${props => props.theme.textMain} !important; 
    }

    .context-selector .arrow { 
        font-size: 12px; 
        color: ${props => props.theme.textSecondary};
     }

    /* Dropdown de Proyectos Refinado */
    .project-dropdown {
        position: absolute;
        top: calc(100% + 8px);
        right: 0;
        background: ${props => props.theme.bgSidebar};
        border: 1px solid ${props => props.theme.border};
        border-radius: 10px;
        box-shadow: 0 8px 24px ${props => props.theme.shadow};
        min-width: 220px;
        max-height: 300px;
        overflow-y: auto;
        padding: 5px;
        z-index: 51;
    }
    
    .project-dropdown-item, .project-dropdown-item-none {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        text-align: left;
        padding: 10px 14px;
        font-size: 14px;
        color: ${props => props.theme.textMain};
        border: none;
        background: none;
        border-radius: 6px;
        cursor: pointer;
        transition: background 0.2s ease;
    }
    .project-dropdown-item:hover { 
        background: ${props => props.theme.hover};
     }
    .project-dropdown-item.active { 
        background: rgba(59, 130, 246, 0.15);
        color: #60a5fa;
        font-weight: 500;
    }

    .dropdown-icon {
        font-size: 16px;
        flex-shrink: 0;
    }

    .project-dropdown-item-none { 
        display: flex;
        padding: 10px 14px;
        color: ${props => props.theme.textSecondary}; 
        font-style: italic; 
        cursor: default;
        font-size: 14px;
    }


    /* Status messages refinados */
    .status-message {
        font-size: 11px;
        margin-top: 6px;
        opacity: 0.7;
        color: ${props => props.theme.textSecondary};
    }
    
    .status-message.error {
        color: #f87171;
    }

    .chat-container {
        flex: 1;
        background: ${props => props.theme.bgMain};
        display: flex;
        flex-direction: column;
        margin: 0 auto; /* Centrar el contenedor */
        border-radius: 0;
        box-shadow: none;
        min-height: 0;
        width: 100%;
        // max-width: 900px; 
        // padding: 0 20px;
    }
    
    .input-wrapper {
        position: relative;
        width: 100%;
        display: block;
        align-items: center;
    }

    .messages { 
        flex: 1; 
        overflow-y: auto; 
        padding: 30px 180px;
        background-color: transparent;
        // min-height: 500px;
    }
    
    .message {
        margin-bottom: 15px;
        padding: 12px 16px;
        border-radius: 12px;
        max-width: 100%;
    }
    
    .user-message {
        background-color: ${props => props.theme.bgMessageUser};
        color: ${props => props.theme.textMain};
        margin-left: auto;
        text-align: left;
    }
    
    .bot-message {
        background-color: ${props => props.theme.bgMessageBot};
        color: ${props => props.theme.textMain};
        border: none;
        line-height: 1.6;
    }

    
    
    .bot-message .chat-action-btn {
        background-color: ${props => props.theme.bgInput};
        color: ${props => props.theme.textMain};
        border: 1px solid ${props => props.theme.border};
        padding: 8px 12px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        transition: all 0.2s;
        margin: 5px;
    }
    .bot-message .chat-action-btn:hover { background-color: ${props => props.theme.hover}; }
    
    .debug-message { background-color: #f39c12; color: white; font-size: 12px; padding: 8px 12px; border-radius: 6px; margin-bottom: 10px; max-width: 100%; }
    
    .input-container {
        padding: 20px;
        background-color: ${props => props.theme.bgMain};      
        display: flex;
        justify-content: center;
        max-width: 900px;
        margin: 0 auto;
        width: 100%;
        position: relative;
    }

    .input-container::before {
        content: '';
        position: absolute;
        top: -10px; /* Altura del efecto de fade */
        left: 0;
        right: 0;
        height: 10px;
        background: linear-gradient(
            to bottom,
            transparent 10%,
            ${props => props.theme.bgMain} 100%
        );
        pointer-events: none; /* No interfiere con clics */
        z-index: 1;
    }
    
    .input-wrapper {
        position: relative;
        width: 100%;
        display: block;
        z-index: 2;
    }
    
    #messageInput {
        width: 100%;
        padding: 12px 55px 12px 20px;
        border: 1px solid ${props => props.theme.border};
        background: ${props => props.theme.bgInput};
        color: ${props => props.theme.textMain};
        border-radius: 25px;
        font-size: 15px;
        outline: none;
        box-shadow: 0 2px 8px ${props => props.theme.shadow};
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        display: block;
        resize: none;
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 120px;
        min-height: 48px;
        line-height: 1.5;
        font-family: inherit;
        word-wrap: break-word;
    }
    
    #messageInput:focus { 
        border-color: ${props => props.theme.textSecondary}; 
        box-shadow: 0 2px 12px ${props => props.theme.shadow}; 
    }
    
    #messageInput::-webkit-scrollbar {
        width: 6px;
    }
    
    #messageInput::-webkit-scrollbar-thumb {
        background-color: ${props => props.theme.scrollThumb};
        border-radius: 10px;
    }
    
    #sendButton {
        position: absolute;
        right: 6px;
        bottom: 6px;
        padding: 10px;
        background: ${props => props.theme.textMain};
        color: ${props => props.theme.bgMain};
        border: none;
        border-radius: 50%;
        cursor: pointer;
        font-size: 16px;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        z-index: 10;
    }
    
    #sendButton:hover:not(:disabled) { 
        transform: scale(1.08);
        box-shadow: 0 2px 8px ${props => props.theme.shadow};
    }
    
    #sendButton:active:not(:disabled) {
        transform: scale(0.95);
    }

    #sendButton:disabled { 
        opacity: 0.4; 
        cursor: not-allowed;
        background: ${props => props.theme.textSecondary};
    }

    
    .loading { color: ${props => props.theme.textSecondary}; font-style: italic; }
    .error { background-color: #e74c3c; color: white; }
    
    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: ${props => props.theme.textSecondary};
        text-align: center;
    }

    .widget-completed-state {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        background-color: rgba(39, 174, 96, 0.1);
        border: 1px solid #27ae60;
        border-radius: 6px;
        color: #27ae60;
        font-weight: bold;
        font-size: 14px;
    }
    
    .empty-state h2 { margin-bottom: 10px; color: ${props => props.theme.textMain}; }
    
    /* --- MENÚ HAMBURGUESA --- */
    /* Por defecto oculto en desktop */
    .hamburger-menu {
        display: none; 
        background: transparent;
        color: ${props => props.theme.textMain};
        border: 1px solid ${props => props.theme.border};
        border-radius: 8px;
        padding: 8px 10px;
        cursor: pointer;
        font-size: 20px;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
    }
    
    .hamburger-menu:hover { 
    background: ${props => props.theme.hover}; 
    border-color: ${props => props.theme.textSecondary};

    }

    .hamburger-menu:active {
        transform: scale(0.95);
    }

    .hamburger-icon {
        display: block;
        line-height: 1;
    }
    
    .sidebar-overlay {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.7);
        z-index: 999;
    }

    .widget-form-container {
        background-color: transparent; /* Se funde con el chat */
        border: 1px solid ${props => props.theme.border};
        border-radius: 16px;
        padding: 30px;
        margin: 20px auto;
        max-width: 450px;
        width: 100%;
    }

    .widget-form-container h4 {
        text-align: center;
        color: ${props => props.theme.textMain};
        font-size: 1.2rem;
        margin-bottom: 30px !important;
        font-weight: 500;
    }

    .widget-form-group {
        display: flex;
        flex-direction: column;
        margin-bottom: 24px;
    }

    .widget-form-group label {
        font-size: 12px;
        color: ${props => props.theme.textSecondary};
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .widget-input {
        padding: 10px 0;
        background-color: transparent;
        border: none;
        border-bottom: 2px solid ${props => props.theme.border};
        color: ${props => props.theme.textMain};
        border-radius: 0;
        outline: none;
        font-size: 15px;
        transition: border-color 0.3s ease;
    }

    .widget-input:focus { border-bottom-color: #27ae60; }

    .widget-submit-btn {
        width: 100%;
        padding: 14px;
        margin-top: 15px;
        background-color: ${props => props.theme.textMain}; /* Botón de alto contraste */
        color: ${props => props.theme.bgMain};
        border: none;
        border-radius: 30px; /* Botón tipo píldora */
        font-weight: bold;
        cursor: pointer;
        transition: opacity 0.2s ease;
    }

    .widget-submit-btn:hover { opacity: 0.8; }
    
    /* --- RESPONSIVE DESIGN (Versión Recuperada) --- */
    
    /* Mobile (< 768px) */
    @media (max-width: 768px) {
        .hamburger-menu {
            display: flex; /* Mostrar botón hamburguesa */
        }
        
        & {
            height:100dvh;
            flex-direction: row; /* Layout general */
        }
        
        .sidebar {
            position: fixed;
            top: 0;
            left: -280px; /* Oculto por defecto */
            width: 280px;
            height: 100dvh;
            z-index: 1000;
            border-right: 1px solid ${props => props.theme.border};
            border-top: none;
            order: initial;
            max-height: none;
            /* box-shadow al abrir */
            box-shadow: 2px 0 10px ${props => props.theme.shadow};
            padding-bottom: env(safe-area-inset-bottom);
        }
        
        .sidebar.open {
            left: 0; /* Mostrar sidebar */
        }
        
        .sidebar-overlay.show {
            display: block; /* Mostrar overlay */
        }
        
        .main-content {
            width: 100%;
            order: initial;
            height: auto;
        }
        
        .chat-header {
            padding: 10px 15px;
        }

        .chat-header-content {
            flex-wrap: nowrap;
            gap: 10px;
        }
        
        .chat-header-left {
            flex: 1;
            min-width: 0;
            gap: 8px;
        }
        
        .header-title-group {
            gap: 0;
        }
        
        .chat-header-title {
            font-size: 16px;
            line-height: 1.2;
        }
        
        .chat-header-subtitle {
            display: block; /* Ocultar en móvil para ahorrar espacio */
            font-size: 9px;
            opacity: 0.6;
            line-height: 1.2;
        }
        
        .subscription-badge {
            font-size: 10px;
            padding: 3px 8px;
        }
        
        .context-selector {
            padding: 5px 10px;
            font-size: 13px;
        }
        
        .context-icon {
            font-size: 14px;
        }

        .context-name {
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        
        .conversations-list {
            max-height: none;
            padding: 10px;
        }
        
        .conversation-actions {
            opacity: 1; /* Siempre visible en táctil */
        }

        .chat-container {
            max-width: 100%;
            padding: 0 10px;
             flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: auto;

            -webkit-overflow-scrolling: touch;
        scroll-behavior: smooth;
        }
        
        .messages {
            padding: 20px 10px;
            // min-height: 400px;
            padding-top: 70px;
            padding-bottom: 20px;
            overflow: unset;
        }
        
        .input-container {
            padding: 5px 15px 10px 10px;
        }
        
        #messageInput {
            font-size: 16px; /* Evita zoom en iOS */
            padding: 12px 50px 12px 16px;

            touch-action: manipulation;
        }
        
        #sendButton {
            width: 36px;
            height: 36px;
        }
    }
    
    /* Mobile muy pequeño (< 480px) */
    @media (max-width: 480px) {
        .sidebar {
            width: 100vw; /* Pantalla completa */
            left: -100vw;
        }
        
        .sidebar.open {
            left: 0;
        }
        
        .chat-header {
            padding: 8px 12px;
        }
        
        .chat-header-title {
            font-size: 14px;
        }

        .chat-header-subtitle {
        font-size: 8px;
    }
        
        .chat-header-content {
            gap: 8px;
        }
        
        .project-dropdown {
            min-width: calc(100vw - 40px);
            max-width: calc(100vw - 40px);
            right: -10px;
        }

        .messages {
            padding-top: 65px; /* Ajuste fino para pantallas más pequeñas */
            padding-left: 8px;
            padding-right: 8px;
        }
    }
    
    /* Landscape en móviles */
    @media (max-width: 768px) and (orientation: landscape) {
        .sidebar {
            width: 280px;
            left: -280px;
        }
        
        .sidebar.open {
            left: 0;
        }
    }
    
    /* Desktop (> 769px) - REGLAS DE REINICIO */
    @media (min-width: 769px) {
        .hamburger-menu {
            display: none !important; /* Asegurar oculto */
        }
        
        .sidebar {
            position: static;
            left: auto;
            border-right: 1px solid ${props => props.theme.border};
            width: 280px;
            height: 100vh;
        }
        
        .sidebar-overlay {
            display: none !important;
        }
        
        .chat-header {
            padding-right: 20px;
        }
    }

   .welcome-actions {
        display: flex;
        flex-wrap: wrap; /* Evita que los botones se corten en pantallas pequeñas */
        gap: 12px;
        margin-top: 15px;
    }

    .welcome-actions .chat-action-btn {
        display: inline-flex;
        align-items: center;
        padding: 10px 18px;
        border-radius: 25px; /* Borde más redondeado para el estilo píldora */
        font-size: 0.95rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        
        /* Uso de los props del tema para resaltar en ambos modos */
        background-color: ${props => props.theme.bgMessageUser};
        color: ${props => props.theme.textMain};
        border: 1px solid ${props => props.theme.border};
        box-shadow: 0 2px 6px ${props => props.theme.shadow}; /* Sombra para dar volumen */
    }

    .welcome-actions .chat-action-btn:hover {
        background-color: ${props => props.theme.hover};
        border-color: ${props => props.theme.textSecondary};
        transform: translateY(-2px); /* Efecto de presionar/flotar */
        box-shadow: 0 4px 10px ${props => props.theme.shadow};
    }

    /* Conversación con dropdown activo */
.conversation-item.dropdown-active {
    background-color: ${props => props.theme.hover};
    border-left: 3px solid #ae3d27;
}

/* Botón del menú activo */
.menu-btn.active {
    background: ${props => props.theme.hover};
    color: ${props => props.theme.textMain};
    border: 2px solid #c9c9c964;
    box-shadow: 0 0 8px rgba(116, 116, 116, 0.3);
    transform: scale(1.05);
}

/* ============================================
   CHAT CHIPS - MINIMAL LUXURY PREMIUM
   ============================================ */

/* CONTENEDOR STACK DE CHIPS */
.chat-chips-stack {
    margin: 20px 0;
    padding: 16px;
    border-radius: 12px;
    animation: stackFadeIn 0.4s ease-out;
}

.chat-chips-stack.disabled {
    opacity: 0.5;
    pointer-events: none;
}

/* Header del stack */
.chips-stack-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(59, 130, 246, 0.1);
}

.chips-stack-icon {
    font-size: 16px;
    line-height: 1;
}

.chips-stack-title {
    font-size: 0.85em;
    font-weight: 600;
    color: ${props => props.theme.textSecondary};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    opacity: 0.8;
}

/* Lista de chips */
.chips-stack-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* CHIP INDIVIDUAL - MODO STACKED */
.chat-chip-stacked {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 12px 16px;
    margin: 0;
    
    background: ${props => props.theme.chipBg || props.theme.bgMessageUser};
    border: 1px solid ${props => props.theme.chipBorder || props.theme.border};
    border-radius: 8px;
    
    color: ${props => props.theme.chipColor || props.theme.linkColor};
    font-size: 0.9em;
    font-weight: 500;
    text-align: left;
    letter-spacing: 0.01em;
    
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    
    white-space: normal;
    word-break: break-word;
    user-select: none;
    
    backface-visibility: hidden;
    -webkit-font-smoothing: antialiased;
    
    box-shadow: none;
}

/* Animación escalonada de entrada */
.chat-chip-stacked:nth-child(1) { animation: chipSlideIn 0.3s ease-out 0.05s both; }
.chat-chip-stacked:nth-child(2) { animation: chipSlideIn 0.3s ease-out 0.1s both; }
.chat-chip-stacked:nth-child(3) { animation: chipSlideIn 0.3s ease-out 0.15s both; }
.chat-chip-stacked:nth-child(4) { animation: chipSlideIn 0.3s ease-out 0.2s both; }
.chat-chip-stacked:nth-child(5) { animation: chipSlideIn 0.3s ease-out 0.25s both; }

.chat-chip-stacked:hover {
    background: none;
    border-color:none;
    transform: translateX(4px);
    
    box-shadow: none;
}

.chat-chip-stacked:active {
    transform: translateX(2px) scale(0.98);
}

/* Flecha del chip stacked */
.chip-arrow {
    font-size: 0.9em;
    opacity: 0.5;
    transition: all 0.2s ease;
    flex-shrink: 0;
    color: ${props => props.theme.linkColor};
}

.chat-chip-stacked:hover .chip-arrow {
    opacity: 1;
    transform: translateX(3px);
}

/* Texto del chip */
.chip-text {
    flex: 1;
    line-height: 1.4;
}

/* CHIP INDIVIDUAL - MODO INLINE */
.chat-chip {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 4px 18px;
    margin: 2px 7px;
    position: relative;
    
    background: none;
    border: none;
    border-radius: 12px;
    
    color: ${props => props.theme.linkColor};
    font-size: 0.88em;
    font-weight: 600;
    letter-spacing: 0.015em;
    
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    
    white-space: normal;
    word-break: break-word;
    max-width: 100%;
    user-select: none;
    
    backface-visibility: hidden;
    -webkit-font-smoothing: antialiased;
    
    animation: chipFadeIn 0.3s ease-out;
}

.chat-chip:hover {
    background: none;
    border-color: none;
    transform: translateY(-2px);
    
    box-shadow: none
}

.chat-chip:active {
    transform: translateY(0);
    background: ${props => props.theme.hover};
    box-shadow: 
        0 1px 3px ${props => props.theme.shadow},
        inset 0 1px 2px rgba(0, 0, 0, 0.08);
}

.chip-icon {
    font-size: 0.7em;
    opacity: 0.5;
    transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    font-weight: 700;
    flex-shrink: 0;
    color: ${props => props.theme.linkColor};
}

.chat-chip:hover .chip-icon {
    opacity: 0.9;
    transform: translate(2px, -2px);
}

/* ESTADO DISABLED */
.chat-chip-disabled,
.chat-chip-disabled.chat-chip-stacked {
    cursor: not-allowed;
    opacity: 0.4;
    pointer-events: none;
    filter: grayscale(0.5);
    animation: none;
}

.chat-chip-disabled:hover,
.chat-chip-disabled.chat-chip-stacked:hover {
    background: none;
    border-color: none;
    transform: none;
    // box-shadow: none;
}

/* FOCUS STATES */
.chat-chip:focus,
.chat-chip-stacked:focus {
    outline: none;
    box-shadow: 
        0 0 0 3px ${props => props.theme.linkColor}33,
        0 1px 3px ${props => props.theme.shadow};
}

/* ANIMACIONES */
@keyframes stackFadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes chipSlideIn {
    from {
        opacity: 0;
        transform: translateX(-10px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes chipFadeIn {
    from {
        opacity: 0;
        transform: translateY(5px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* RESPONSIVE - CHIPS */
@media (max-width: 768px) {
    .chat-chips-stack {
        padding: 12px;
        margin: 16px 0;
    }
    
    .chips-stack-header {
        margin-bottom: 10px;
        padding-bottom: 8px;
    }
    
    .chips-stack-title {
        font-size: 0.8em;
    }
    
    .chips-stack-list {
        gap: 6px;
    }
    
    .chat-chip-stacked {
        padding: 10px 14px;
        font-size: 0.85em;
        gap: 8px;
    }
    
    .chat-chip {
        padding: 6px 14px;
        font-size: 0.85em;
        margin: 5px 6px;
        border-radius: 10px;
        gap: 6px;
        max-width: calc(100vw - 60px);
        line-height: 1.4;
    }
    
    .chip-icon {
        font-size: 0.65em;
    }
    
    .chip-arrow {
        font-size: 0.85em;
    }
    
    .chat-chip-disabled {
        opacity: 0.35;
    }
}

@media (max-width: 480px) {
    .chat-chips-stack {
        padding: 10px;
        margin: 12px 0;
    }
    
    .chat-chip-stacked {
        padding: 9px 12px;
        font-size: 0.82em;
    }
    
    .chat-chip {
        padding: 5px 12px;
        font-size: 0.82em;
        margin: 4px 5px;
        border-radius: 9px;
        max-width: calc(100vw - 50px);
    }
}

/* PRINT STYLES - CHIPS */
@media print {
    .chat-chips-stack {
        background: transparent;
        border: 1px solid #ccc;
    }
    
    .chat-chip,
    .chat-chip-stacked {
        background: transparent;
        border: 1px solid #999;
        box-shadow: none;
    }
    
    .chip-arrow,
    .chip-icon {
        display: none;
    }
}

.language-selector-wrapper {
  position: relative;
  margin-right: 1rem;
}

.language-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0rem 0rem;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.language-selector:hover {
  background: none;
  border-color: none ;
}

.language-icon {
  width: 20px;
  height: 20px;
  color: ${props => props.theme.textMain}
}

.language-code {
  font-size: 0.875rem;
  font-weight: 500;
  color: ${props => props.theme.textMain}
}

.language-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  z-index: 1000;
}

.language-dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
}

.language-dropdown-item:hover {
  background: #f5f5f5;
}

.language-dropdown-item.active {
  background: #e3f2fd;
  color: #1976d2;
}

.language-abbr {
  font-size: 0.75rem;
  font-weight: 600;
  color: #666;
}

.language-dropdown-item.active .language-abbr {
  color: #1976d2;
}

/* Estilos para el dropdown de idiomas con scroll */
.language-dropdown-scrollable {
    max-height: 200px; /* Altura para mostrar aproximadamente 4 items */
    overflow-y: auto;
    overflow-x: hidden;
}

/* Scrollbar sutil para el dropdown */
.language-dropdown-scrollable::-webkit-scrollbar {
    width: 4px;
}

.language-dropdown-scrollable::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
}

.language-dropdown-scrollable::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 4px;
}

.language-dropdown-scrollable::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.5);
}

/* Ajustar el tamaño de los items para que sean más compactos */
.language-dropdown-item {
    padding: 8px 12px;
    font-size: 0.9rem;
}

.language-name {
    font-size: 0.85rem;
}

.language-abbr {
    font-size: 0.75rem;
    opacity: 0.7;
}

.beta-badge {
    display: inline-block;
    margin-left: 8px;
    padding: 2px 6px;
    font-size: 0.5em;
    font-weight: 600;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 4px;
    vertical-align: super;
    letter-spacing: 0.5px;
}

@media (max-width: 768px) {
    .beta-badge {
        margin-left: 4px;
        padding: 1px 4px;
        font-size: 0.45em;
        border-radius: 3px;
    }
}

/*Info beta projects*/

.project-dropdown {
  max-height: none !important; /* Remover límite de altura */
  min-width:300px!important;
  height: auto;
  overflow: visible; /* Cambiar de scroll/auto a visible */
}

/* Ajustar la noticia de beta */
.project-dropdown-beta-notice {
  padding: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px 8px 0 0;
  margin-bottom: 8px;
}

.beta-notice-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.info-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.beta-notice-title {
  font-weight: 600;
  font-size: 13px;
}

.beta-notice-description {
  font-size: 12px;
  margin: 0;
  opacity: 0.95;
  line-height: 1.3;
}

/* Ajustar la sección de información */
.project-info-section {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 0 0 8px 8px;
}

.project-info-title {
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 6px 0;
}

.project-info-text {
  font-size: 12px;
  color: #5a6c7d;
  line-height: 1.5;
  margin: 0;
}

/* Ajustes específicos para mobile */
@media (max-width: 768px) {
  .project-dropdown {
    width: calc(100vw - 32px); /* Ancho completo menos padding */
    //max-width: 400px;
    right: 16px;
  }
  
  .project-dropdown-beta-notice {
    padding: 10px;
  }
  
  .beta-notice-title {
    font-size: 12px;
  }
  
  .beta-notice-description {
    font-size: 11px;
    line-height: 1.3;
  }
  
  .project-info-section {
    padding: 10px;
  }
  
  .project-info-title {
    font-size: 12px;
    margin-bottom: 4px;
  }
  
  .project-info-text {
    font-size: 11px;
    line-height: 1.4;
  }
  
  .info-icon {
    width: 16px;
    height: 16px;
  }
}

/* Para pantallas muy pequeñas */
@media (max-width: 480px) {
  .project-dropdown {
    width: calc(100vw - 24px);
    right: 12px;
  }
  
  .beta-notice-title {
    font-size: 11px;
  }
  
  .beta-notice-description {
    font-size: 10px;
  }
  
  .project-info-title {
    font-size: 11px;
  }
  
  .project-info-text {
    font-size: 10px;
  }
}

/* End beta projects */


/* ============================================
       BOTTOM SHEET ANIMATIONS
       ============================================ */

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            transform: translateY(100%);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    /* Bottom Sheet Overlay */
    .bottom-sheet-overlay {
        transition: opacity 0.25s ease-out;
    }

    /* Bottom Sheet - Smooth scrolling en contenido largo */
    .bottom-sheet {
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        scrollbar-color: #565869 transparent;
    }

    .bottom-sheet::-webkit-scrollbar {
        width: 6px;
    }

    .bottom-sheet::-webkit-scrollbar-track {
        background: transparent;
    }

    .bottom-sheet::-webkit-scrollbar-thumb {
        background-color: #565869;
        border-radius: 10px;
    }

    /* ============================================
       DROPDOWN ANIMATIONS (Desktop)
       ============================================ */

    @keyframes dropdownSlideIn {
        from {
            opacity: 0;
            transform: translateY(-8px) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    /* Dropdown menu chat - mejorado */
    .dropdown-menu-chat {
        animation: dropdownSlideIn 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

    /* ============================================
       RESPONSIVE ADJUSTMENTS
       ============================================ */

    @media (max-width: 768px) {
        /* Asegurar que el bottom sheet funcione correctamente */
        .bottom-sheet-container {
            touch-action: none; /* Prevenir scroll durante interacción */
        }

        /* Mejorar área de toque en mobile */
        .conversation-item .menu-btn {
            min-width: 44px;
            min-height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        /* Asegurar que conversation actions sean siempre visibles en táctil */
        .conversation-item .conversation-actions {
            opacity: 1;
        }
    }

    /* Tablet y desktop - mantener hover effect */
    @media (min-width: 769px) {
        .conversation-item .conversation-actions {
            opacity: 0;
        }

        .conversation-item:hover .conversation-actions {
            opacity: 1;
        }
    }

    /* ============================================
       ACCESSIBILITY IMPROVEMENTS
       ============================================ */

    /* Focus visible para navegación por teclado */
    .bottom-sheet button:focus-visible,
    .dropdown-item-chat:focus-visible {
        outline: 2px solid #60a5fa;
        outline-offset: 2px;
    }

    /* Reduced motion para usuarios sensibles */
    @media (prefers-reduced-motion: reduce) {
        .bottom-sheet,
        .bottom-sheet-overlay,
        .dropdown-menu-chat {
            animation: none !important;
            transition: none !important;
        }
    }
        
`;